import naturopolis from "./naturopolis/naturopolis"
const all_game_packs = [naturopolis];
export default all_game_packs;